import clsx from "clsx";
import React from "react";
import { useTheme } from "../../hooks";
import { ChipStylesVariantType } from "../../types";
import { ChipVariant } from "../../types/ChipType";
import { Icon } from "../icon";
import { ChipContainer } from "./ChipStyles";

type ChipProps = {
  variant: ChipVariant;
  label: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  onDelete?: () => void;
  className?: string;
  styles?: ChipStylesVariantType;
};

/**
 * Show a chip!
 */
const Chip: React.FC<ChipProps> = ({ variant, label, onClick, onDelete, disabled = false, className, styles = {} }) => {
  const { Theme } = useTheme();
  const VariantTheme: ChipStylesVariantType = Theme.chip[disabled ? "disabled" : variant];
  const StylesOverride: ChipStylesVariantType = { ...VariantTheme, ...styles };
  return (
    <div>
      <ChipContainer
        styles={StylesOverride}
        onClick={!disabled ? onClick : undefined}
        className={clsx("bcr-chip", className)}
      >
        <div>{label}</div>
        {!!onDelete && (
          <Icon
            className="ms-2"
            iconName="fa-trash-alt"
            onClick={!disabled ? onDelete : undefined}
            styles={{ color: StylesOverride.color }}
          />
        )}
      </ChipContainer>
    </div>
  );
};

export default Chip;
